import $foreign from "./foreign.cjs";
var _crashWith = $foreign._crashWith;
export { _crashWith };
